﻿<rdo-breadcrumb></rdo-breadcrumb>
<div id="customer" [rdoFillRemainingHeight]>
  <div class="d-flex flex-row position-relative align-items-stretch scroll-container" [rdoCollapsedCards]="'customer'">
    <rdo-collapsible [key]="'customer'">
      <div class="rdo-col-card-fixed scroll"
        infinite-scroll
        [infiniteScrollThrottle]="500"
        (scrolled)="getPaginatedCards()"
        [scrollWindow]="false">
        <div class="rdo-card-list">
          @for (c of customerCards; track c; let baseId = $index) {
            <rdo-nav-card-book
              [baseId]="baseId"
              [data]="c" [titleSelector]="'CustomerName'"
              [selected]="isSelected(c)"
              [icon]="'fa-building'"
              [comparisonMode]="mode"
              (selectedChange)="select(c)"
              [rdo-scroll-into]="isSelected(c)">
            </rdo-nav-card-book>
          }
        </div>
      </div>
    </rdo-collapsible>
    <div class="rdo-col-card-offset container-fluid scroll-container collapsible-offset">
      <div class="row">
        <div class="col-12">
          <h3>
            <i class="fa fa-building"></i>
            {{selectedCustomer?.CustomerName}}
          </h3>
        </div>
      </div>
      <div class="row margin-bottom-xl">
        <div class="col-12">
          <ul class="nav nav-pills rdo-nav-pills">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <a class="nav-link" [routerLink]="['./']" id="customer-dashboard-tab" [attr.data-text]="'main.core.common.dashboard' | translate"
              >{{'main.core.common.dashboard' | translate}}</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['sales-reps']" id="customer-sales-reps-tab" [attr.data-text]="'main.core.common.counts.sales_reps.plural' | translate"
              >{{'main.core.common.counts.sales_reps.plural' | translate}}</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['product-types']" id="customer-product-types-tab"
                [attr.data-text]="'main.core.common.counts.product_types.plural' | translate"
              >{{'main.core.common.counts.product_types.plural' | translate}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" id="customer-content">
        <div class="scroll-container col-12">
          <div class="scroll active container-fluid">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
